module.exports = {"TXTCLI_Current_Balance":{"id":"TXTCLI_Current_Balance","defaultMessage":"Текущий баланс","flags":["TRACK"],"track":"Current Balance"}}